import EnergyAnalyzerFilterInput from '@/components/forms/energyxplorer/EnergyAnalyzerFilterInput';
import {
  Dialog,
  DialogTitle,
  DialogActions,
  CircularProgress,
} from '@mui/material';
import { Suspense } from 'react';

const TreeGraphFilterInput = ({
  open,
  onClose,
  handleApply,
  selectedEnergyGroup,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Filtrer data</DialogTitle>
      <Suspense fallback={<CircularProgress />}>
        <EnergyAnalyzerFilterInput
          handleApply={handleApply}
          selectedEnergyGroup={selectedEnergyGroup}
          startHour={selectedEnergyGroup?.options?.workingDayStart}
          endHour={selectedEnergyGroup?.options?.workingDayEnd}
          setComparisonFilters={() => {}}
        />
      </Suspense>

      <DialogActions sx={{ p: 0 }}></DialogActions>
    </Dialog>
  );
};

export default TreeGraphFilterInput;
